import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { globals } from '../globals';

@Injectable({
  providedIn: 'root'
})
export class RZKService {

  constructor(private http: HttpClient) { }

  buscarLinkDeAcesso(idIntegrador) {
    return this.http.get<any>(globals.apiUrl + '/api/RZK/BuscarLinkDeAcesso', {
      params: new HttpParams().set('idIntegrador', idIntegrador)
    });
  }

  possuiRzkId(idIntegrador) {
    return this.http.get<any>(globals.apiUrl + '/api/RZK/PossuiRzkId', {
      params: new HttpParams().set('idIntegrador', idIntegrador)
    });
  }

}
